import React, { FC, ReactNode } from 'react'
import { Typography } from '@mui/material'
import { withProps } from '@utils/hoc'
import { withStyles } from '@mui/styles'

const Title = withStyles({
  root: {
    fontSize: '25px'
  }
})(withProps(Typography, { variant: 'h2', component: 'h2' }))

type ListItemProps = {
  text: string
  icon?: ReactNode
}

const ListItem: FC<ListItemProps> = ({ icon, text }) => {
  return (
    <>
      <div className="mt-[20px] flex flex-row flex-nowrap items-start justify-start gap-4">
        <div className="h-[24px] w-[24px] flex-shrink-0">{icon}</div>
        <Typography>{text}</Typography>
      </div>
    </>
  )
}

type Props = {
  title: string
  image: ReactNode
  items: Array<ListItemProps>
  reverse?: boolean
}

const ParagraphWithImage: FC<Props> = ({ title, image, items, reverse }) => {
  return (
    <>
      <div className={`flex flex-wrap items-center justify-center lg:justify-between ${reverse ? 'sm:flex-row-reverse' : ''}`}>
        {image}
        <div className="mx-[20px] flex flex-col items-start justify-between sm:mx-0 sm:w-[445px]">
          <Title>{title}</Title>
          {items.map((item, key) => (
            <ListItem key={key} text={item.text} icon={item.icon} />
          ))}
        </div>
      </div>
    </>
  )
}

export default ParagraphWithImage
